import{__require as r}from"./fails.js";var e,t;function n(){if(t)return e;t=1;var n=r();return e=!n((function(){return 7!==Object.defineProperty({},1,{get:function(){return 7}})[1]}))}export{n as __require};
//# sourceMappingURL=descriptors.js.map
